import Bottleneck from 'bottleneck';

import { removeAuthTokens } from './TokenHelper';

export const limiter = new Bottleneck({
  maxConcurrent: 1,
  minTime: 333 // limit to 3 requests per second
});

const customFetch = limiter.wrap(window.fetch);

export function rateLimitedfetch(url, ...args) {
  return customFetch(url, ...args).then(res => {
    if (res.status === 401) {
      setTimeout(logOutAndReload, 0);
    }
    return res;
  });
}

export function makeRateLimitedFetch(limit, maxConcurrent = 1) {
  const limiter = new Bottleneck({
    maxConcurrent,
    minTime: 1000 / limit
  });
  const customFetch = limiter.wrap(window.fetch);
  return function rateLimitedfetch(url, ...args) {
    return customFetch(url, ...args).then(res => {
      if (res.status === 401) {
        setTimeout(logOutAndReload, 0);
      }
      return res;
    });
  };
}

function logOutAndReload() {
  removeAuthTokens();
  window.location.reload();
}
